<div class="identification-container">
   <div class="wizard-content">
      <router-outlet></router-outlet>
   </div>
</div>
